module.exports = __webpack_public_path__ + "static/media/services_staffing.485ed6cf.jpg";